__turbopack_context__.v({
  "Contact": "Person-module-scss-module__W8it4G__Contact",
  "Content": "Person-module-scss-module__W8it4G__Content",
  "IsCircle": "Person-module-scss-module__W8it4G__IsCircle",
  "IsSquare": "Person-module-scss-module__W8it4G__IsSquare",
  "Name": "Person-module-scss-module__W8it4G__Name",
  "Person": "Person-module-scss-module__W8it4G__Person",
  "PersonCircle": "Person-module-scss-module__W8it4G__PersonCircle",
  "PersonCircleImage": "Person-module-scss-module__W8it4G__PersonCircleImage",
  "PersonSquare": "Person-module-scss-module__W8it4G__PersonSquare",
  "PersonSquareImage": "Person-module-scss-module__W8it4G__PersonSquareImage",
  "Role": "Person-module-scss-module__W8it4G__Role",
});
